<template>
  <div class="cooling-efficiency-dropdown">
    <label for="norms">
      {{ $t('engineering.norm') }}
    </label>
    <s-select
      id="norms"
      class="cooling-efficiency-dropdown__norms"
      v-model="norm"
      value-field="id"
      text-field="name"
      :disabled="loadingNorms"
      :options="norms"
      @input="onChangeNorm"
    >
      <span
        class="d-flex align-items-center"
        slot="item"
        slot-scope="data"
      >
        <cooling-efficiency-situation-icon
          v-if="!data.situation.includes('normal')"
          class="mr-2"
          :show-tooltip="false"
          :situation="data.situation"
        />
        <span>
          {{ data.name }}
        </span>
      </span>
    </s-select>
  </div>
</template>

<script>
import eventBus from '@/services/globalEventBus';
import coolingEfficiencyEvents from '@/domain/events/coolingEfficiency';
import Service
  from '@/domain/services/installation/engineering/coolingEfficiency/coolingEfficiencyService';
import CoolingEfficiencySituationIcon
  from '@/domain/components/installation/engineering/coolingEfficiency/CoolingEfficiencySituationIcon';
import engineeringEvents from '@/domain/events/engineering';

export default {
  props: {
    selectedNorm: {
      type: String,
      default: '',
    },
    emitEvent: {
      type: Boolean,
      default: true,
    },
    tabInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    CoolingEfficiencySituationIcon,
  },
  data: vm => ({
    norms: [],
    norm: vm.selectedNorm,
    loadingNorms: false,
  }),
  created() {
    this.initListeners();
    this.refreshData();
  },
  beforeDestroy() {
    this.removeListeners();
  },
  methods: {
    initListeners() {
      eventBus.on(engineeringEvents.refreshDataTab, this.refreshData);
    },
    removeListeners() {
      eventBus.off(engineeringEvents.refreshDataTab, this.refreshData);
    },
    getNorms() {
      const { assetModuleId } = this.$route.params;
      this.loadingNorms = true;
      Service.getNorms(assetModuleId).then((response) => {
        this.norms = response;
      }).finally(() => {
        this.loadingNorms = false;
      });
    },
    refreshData() {
      if (!this.tabInfo.status?.lastUpdate) return;
      this.getNorms();
    },
    onChangeNorm(newValue) {
      this.$emit('change-norm', newValue);
      if (!this.emitEvent) return;
      eventBus.emit(coolingEfficiencyEvents.refreshSelectedNorm, newValue);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .cooling-efficiency-dropdown
    padding-bottom: 15px

    &__norms ::v-deep
      .situation-icon
        width: 1.5em
        text-align: center

      .dropdown-item
        .fas
          font-size: 1em

        svg
          width: 1.5em
          height: 1.5em

        &:hover
          .fas
            color: white

          svg path
            fill: white
</style>
